<template>
    <div>
        <top-bar
            :lbl="lbl"
            activeTab="history"
            :profile="profile"
            :isLogin="isLogin"
            @switchLang="switchLang($event)"
            @logout="logout()"
        ></top-bar>
        <div class="container">
            <BurnList
                :lbl="lbl"
                :listConfig="purchaseListConfig"
                :filterConfig="purchaseFilterListConfig"
                :busEvent="busHistory"
                :isLoading="isLoading"
                @toggleLoading="toggleLoading($event)" />
        </div>
    </div>
</template>
<script>
// library
import Vue from "vue";
import Util from "@/helper/Utility.js";
import ConfigManager from "@/config/ConfigManager.js";
import CacheHelper from "@/helper/CacheHelper.js";
// helper
import Locale from "@/helper/locale/locale.js";
// import Account from "@/helper/AccountHelper.js";
// component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
// core
import BurnList from "../component/BurnList.vue";
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
    PointListConfigBuilder
} from "@/core/History/model/HistoryConfigModel.js";

export default {
    name: "History",
    mixins: [AccountMixin],
    components: {
        TopBar,
        BurnList
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isLoading: false,
            purchaseListConfig: {},
            purchaseFilterListConfig: {},
            pointListConfig: {},
            busHistory: new Vue(),
        };
    },
    created: function() {
        this.initialIsFromLanding();
        this.initialBurn();
    },
    methods: {
        initialBurn: function () {
            //initial config for api.
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseList())
                .setTop(25)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },
        initialEarnPoint: function () {
            //initial config for api.
            var listConfig = new PointListConfigBuilder()
                .setDate('')
                .create();
            this.pointListConfig = listConfig;
        },
        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            var formLanding = Util.jsonParse(cacheHelper.getCache('isfromlanding'));

            if (formLanding != null) {
                cacheHelper.removeCache('isfromlanding');
            }
        },
        //#endregion initial
        initialExpiringPoint: function () {

        },

        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
    }
};
</script>
